import { render, staticRenderFns } from "./remixIcon.vue?vue&type=template&id=b4579644&scoped=true&"
import script from "./remixIcon.vue?vue&type=script&lang=js&"
export * from "./remixIcon.vue?vue&type=script&lang=js&"
import style0 from "./remixIcon.vue?vue&type=style&index=0&id=b4579644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4579644",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4579644')) {
      api.createRecord('b4579644', component.options)
    } else {
      api.reload('b4579644', component.options)
    }
    module.hot.accept("./remixIcon.vue?vue&type=template&id=b4579644&scoped=true&", function () {
      api.rerender('b4579644', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vab/icon/remixIcon.vue"
export default component.exports